// 表格混入文件
export default {
  data() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    return {
      userInfo:userInfo,
      type: {
        A: 'warning',
        Y: 'success',
        N: 'danger',
      },
      //审批状态
      approveStateObj: {
        A: '待审批',
        Y: '合格',
        N: '不合格',
      },
    }
  },
  
  methods: {
    //处理业务指派人员
    getbelongStaffsName(row) {
      let { belongStaffs } = row
      if (Array.isArray(belongStaffs) && belongStaffs.length) {
        return belongStaffs.length > 2 ? `${((belongStaffs.slice(0, 2)).map(item=>item.staffName)).join()}等${belongStaffs.length}人` : (belongStaffs.map(item=>item.staffName)).join()
      } else {
        return '-'
      }
    },
    // 勾选表格
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    //查看历史审核记录
    historyReviewRecords(item, type) {
      this.$emit('historyReviewRecords', item, type);
    },
    //去审核
    toAudit(val) {
      this.$emit('toAudit', val);
    },
    // 查看详情
    toDetail(val) {
      this.$emit('toDetail', val);
    },
    getFieldConfig(params, key,attr) {
      var fieldList = JSON.parse(localStorage.getItem(attr));
      var newConfig = {};
      if (!fieldList) return
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return (newConfig && newConfig[key]) || undefined;
    },
    transform(list) {
      if (!list) return;
      var newList = [];
      list.forEach((item) => {
        newList.push({
          name: item.text,
          value: item.value,
        });
      });
      return newList;
    },
    
    
    
  },
}